// Carlo Luccioni suggests us to use a more standard breakpoint for mobile devices of 375 pixels (23.4em)
const breakpoints = {
  xxs: 320,
  xs: 375,
  sm: 744,
  md: 834,
  mdPlus: 992,
  lg: 1024,
  lgPlus: 1151,
  xl: 1280,
  xxl: 1440,
};

const customCss = {
  breakpoints: {
    xxs: `(min-width: ${breakpoints.xxs}px)`, // 320
    xs: `(min-width: ${breakpoints.xs}px)`, // 375
    sm: `(min-width: ${breakpoints.sm}px)`, // 744
    md: `(min-width: ${breakpoints.md}px)`, // 834
    mdPlus: `(min-width: ${breakpoints.mdPlus}px)`, // 992
    lg: `(min-width: ${breakpoints.lg}px)`, // 1024
    lgPlus: `(min-width: ${breakpoints.lgPlus}px)`, // 1151
    xl: `(min-width: ${breakpoints.xl}px)`, // 1280
    xxl: `(min-width: ${breakpoints.xxl}px)`, // 1440
    mobileLandscape: '(min-aspect-ratio: 16/10) and (max-width: 80rem)',
    smOnly: `(min-width: ${breakpoints.sm}px) and (max-width: ${breakpoints.xl - 1}px)`,
  },
  breakpointsValues: breakpoints,
  borders: {
    // after the following snippet you need to put 'border-[top | bottom]: 1px dashed;'
    dashedHorizontal:
      'border: 0; border-image: repeating-linear-gradient(to right, #cfcfcf 0, #cfcfcf 2px, transparent 2px, transparent 6px) 1',
    // after the following snippet you need to put 'border-[top | bottom]: 1px dashed;'
    dashedTinyHorizontal:
      'border: 0; border-image: repeating-linear-gradient(to right, #BABAC0 0, #BABAC0 2px, transparent 2px, transparent 4px) 1',
    // after the following snippet you need to put 'border-[right | left]: 1px dashed;'
    dashedVertical:
      'border: 0; border-image: repeating-linear-gradient(to bottom, #cfcfcf 0, #cfcfcf 2px, transparent 2px, transparent 6px) 1',
  },
  gradients: {
    flashSaleDeal: 'linear-gradient(to right, #f78300, #ffb300)',
    lmnDeal: 'linear-gradient(to right, #c20064, #f2007d)',
  },
  colors: {
    flashSaleDealAdditionalValueCheck: '#ffb511',
  },
} as const;

export default customCss;
